const monthNames = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
const dayNames = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

$(document).ready(function() {
    var csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vReOTF3FH-MRV7IuKFLYfhTh4zdi1jtThA_60No2fmVn0qEa6cL4xeiHlhRXgaQS14Zejnwz5cMbrcF/pub?gid=1625515532&single=true&output=csv';
    var storedData = sessionStorage.getItem('calendarData');
    Papa.parse(csvUrl, {
        download: true,
        header: true,
        delimiter: ",",
        complete: function(results) {
            var data = results.data;
            initializeCalendar(data);
        }
    });
   /* if (storedData) {
        var data = JSON.parse(storedData);
        ;
    } else {
        Papa.parse(csvUrl, {
            download: true,
            header: true,
            delimiter: ",",
            complete: function(results) {
                var data = results.data;
                sessionStorage.setItem('calendarData', JSON.stringify(data));
                initializeCalendar(data);
            }
        });
    }*/
});

function initializeCalendar(data) {
    var currentMonth = new Date().getMonth();
    var currentYear = new Date().getFullYear();
    renderCalendar(currentMonth, currentYear, data);

    $('#calendar').on('click', '.prev-month', function() {
        currentMonth = (currentMonth - 1 + 12) % 12;
        if (currentMonth === 11) currentYear -= 1;
        renderCalendar(currentMonth, currentYear, data);
    });

    $('#calendar').on('click', '.next-month', function() {
        currentMonth = (currentMonth + 1) % 12;
        if (currentMonth === 0) currentYear += 1;
        renderCalendar(currentMonth, currentYear, data);
    });

    $(document).on('click', '#calendar .day.has-event', function() {
        var date = $(this).data('date');
        var events = data.filter(item => item["Datum"] === date);
        var popupContent = events.map(event => {
            let actionLinkHtml = "";
            if (event["Odkaz na akci"]) {
                actionLinkHtml = `<div class="actionLink"><a href="${event["Odkaz na akci"]}" target="_blank">Odkaz na akci</a></div>`;
            }
        
            return `
                <div class="title">Detail akce <span class="closePoint"></span></div>
                <div class="yearLine"><p>${event["Datum"]}</p><span class="social"><span class="googleCalendar"></span><!--span class="shareFacebook"></span--></div></div>
                <div class="name"><p>${event["Název akce"]}</p></div>
                <div class="adress"><p>${event["Adresa"]}</p></div>
                <div class="time"><p>${event["Čas"]}</p></div>
                <div class="description"><p>${event["Popis"]}</p></div>
                ${actionLinkHtml}
            `;
        });
        $('#popup').html(popupContent).addClass('open');
    });

    // Hide popup when clicking outside of a day with an event
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.day.has-event').length) {
            $('#popup').removeClass('open')
        }
    });
}

function renderCalendar(month, year, data) {
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var firstDay = new Date(year, month, 1).getDay();
    var firstDayAdjusted = (firstDay === 0 ? 6 : firstDay - 1);
    var daysInPrevMonth = new Date(year, month, 0).getDate();
    var calendarHtml = `<div class="month">
                            <button class="prev-month">Previous</button>
                            ${monthNames[month]} ${year}
                            <button class="next-month">Next</button>
                        </div>
                        <div class="day-names">`;

    dayNames.forEach(day => {
        calendarHtml += `<div class="day-name">${day}</div>`;
    });

    calendarHtml += `</div><div class="days">`;

    for (var i = firstDayAdjusted; i > 0; i--) {
        var dateStr = `${daysInPrevMonth - i + 1}.${(month === 0 ? 12 : month)}.${(month === 0 ? year - 1 : year)}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${daysInPrevMonth - i + 1}</div>
                        </div>`;
    }

    for (var day = 1; day <= daysInMonth; day++) {
        var dateStr = `${day}.${(month + 1)}.${year}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        calendarHtml += `<div class="day ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                            <div class="inner">${day}</div>
                        </div>`;
    }

    var daysInNextMonth = 42 - (firstDayAdjusted + daysInMonth); // Ensuring 6 weeks display
    var displayNextMonthDays = true;

    for (var j = 1; j <= daysInNextMonth; j++) {
        var dateStr = `${j}.${(month + 2 === 13 ? 1 : month + 2)}.${(month + 2 === 13 ? year + 1 : year)}`;
        var hasEvent = data.some(item => item["Datum"] === dateStr);
        if (displayNextMonthDays) {
            calendarHtml += `<div class="day other-month ${hasEvent ? 'has-event' : ''}" data-date="${dateStr}">
                                <div class="inner">${j}</div>
                            </div>`;
        }
    }

    calendarHtml += '</div><div id="popup"></div>';
    $('#calendar').html(calendarHtml);

    // Check if last week contains only next month days
    const days = $('#calendar .days .day');
    const lastWeekDays = days.slice(-7);
    const lastWeekContainsOnlyNextMonthDays = lastWeekDays.toArray().every(day => $(day).hasClass('other-month'));

    if (lastWeekContainsOnlyNextMonthDays) {
        lastWeekDays.remove();
    }
}

$(document).on('click', '.googleCalendar', function(event) {
    event.preventDefault();
    var eventTitle = $(this).closest('#popup').find('.name p').text().trim();
    var eventDescription = $(this).closest('#popup').find('.description p').text().trim();
    var eventLocation = $(this).closest('#popup').find('.adress p').text().trim();
    var eventDate = $(this).closest('#popup').find('.yearLine p').text().trim(); // formát: DD.MM.YYYY
    var eventTime = $(this).closest('#popup').find('.time p').text().trim(); // formát: HH:MM - HH:MM
        
    // Převeďte datum a časy na formát YYYYMMDDTHHmmssZ
    var dateParts = eventDate.split(".");
    var startDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    var timeParts = eventTime.split("-");
    var startTime = timeParts[0].split(":");
    var endTime = timeParts[1].split(":");
   
    startDate.setHours(startTime[0], startTime[1]);
    var startDateString = startDate.toISOString().replace(/-|:|\.\d\d\d/g, "");
    
    var endDate = new Date(startDate);
    endDate.setHours(endTime[0], endTime[1]);
    var endDateString = endDate.toISOString().replace(/-|:|\.\d\d\d/g, "");
        
    // Vytvořte URL pro Google Kalendář
    var googleCalendarUrl = "https://www.google.com/calendar/render?action=TEMPLATE" +
    "&text=" + encodeURIComponent(eventTitle) +
    "&dates=" + startDateString + "/" + endDateString +
    "&details=" + encodeURIComponent(eventDescription) +
    "&location=" + encodeURIComponent(eventLocation) +
    "&sf=true&output=xml";
    
    // Otevřete URL v novém okně nebo záložce
    window.open(googleCalendarUrl, '_blank');
});


$(document).on('click', '.shareFacebook', function(event) {
    event.preventDefault();
    
    // Definujte údaje o události
    var eventTitle = $(this).closest('#popup').find('.name p').text().trim();
    var eventDescription = $(this).closest('#popup').find('.description p').text().trim();
    var eventLocation = $(this).closest('#popup').find('.adress p').text().trim();
    var eventDate = $(this).closest('#popup').find('.yearLine p').text().trim(); // formát: DD.MM.YYYY
    var eventTime = $(this).closest('#popup').find('.time p').text().trim(); // formát: HH:MM - HH:MM
    // Vytvořte URL pro sdílení na Facebooku
    var facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href) +
        "&quote=" + encodeURIComponent(eventTitle + "\n" + eventDescription + "\n" + eventLocation + "\n" + eventDate + " " + eventTime);
    
    // Otevřete URL v novém okně nebo záložce
    window.open(facebookUrl, '_blank');
});